import { render } from 'react-dom'
import * as serviceWorker from '@/infra/serviceWorker'
import { identifyMaybe } from '@/shared'
import { MoteAppEntryPoint } from './MoteAppEntryPoint'

render(<MoteAppEntryPoint />, document.getElementById('root'))
identifyMaybe()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
